import { getUser } from "../../auth";
import ActivityDeleteButton from  "../components/ActivityDeleteButton";

const URL = process.env.REACT_APP_API_URL;

export default function ActivityDelete({ selectedActivities, onDelete }) {
  const handleDelete = () => {
    const user = getUser();
    Promise.all(
      selectedActivities.map((activityId) =>
        fetch(`${URL}/api/activity/${activityId}`, {
          method: "DELETE",
          headers: {
            "X-Empresa-Id": user?.empresa_id,
          }
        })
      )
    )
      .then(() => {
        onDelete();
      })
      .catch((error) => console.error("Error deleting activities:", error));
  };

  return (
    <ActivityDeleteButton
      selectedCount={selectedActivities.length}
      onClick={handleDelete}
      disabled={selectedActivities.length === 0}
    />
  );
}
